// FILE: src/supabaseClient.js

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL;

const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL) {
  throw new Error(
    "Missing REACT_APP_SUPABASE_URL. Add it to the project root .env file."
  );
}

if (!SUPABASE_ANON_KEY) {
  throw new Error(
    "Missing REACT_APP_SUPABASE_ANON_KEY. Add it to the project root .env file."
  );
}

export const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: "pv.supabase.auth",
    },
  }
);